module.exports = __webpack_public_path__ + "media/images/mailer/badge_1-b3b66aaeef2e26dee0593acd2fdb2660.png";